import React from 'react';
import { Input, Select } from 'clad';

const { Option } = Select;

const disabledStyle = {
    opacity: 0.6,
    pointerEvents: 'none'
};

const Frequency = React.forwardRef((props, ref) => {
    const { disabled = false, value = {}, onChange } = props;
    const { frequency = 1, type = 'D' } = value;

    const handleChangeFrequency = e => {
        const { value } = e.target;
        const reg = /^([1-9][0-9]*)/;

        if ((!isNaN(value) && reg.test(value)) || value === '') {
            if (onChange) {
                onChange({
                    frequency: value,
                    type
                });
            }
        }
    };

    const handleChangeFrequencyType = value => {
        if (onChange) {
            onChange({
                frequency,
                type: value
            });
        }
    };

    return (
        <span ref={ref} style={disabled ? disabledStyle : {}}>
            <Input
                type="text"
                defaultValue="1"
                value={frequency}
                style={{ width: '30%', marginRight: '3%' }}
                onChange={handleChangeFrequency}
            />
            <Select
                style={{ width: '65%' }}
                value={type}
                onChange={handleChangeFrequencyType}
                defaultValue="D"
            >
                <Option value="s">{_('Seconds')}</Option>
                <Option value="m">{_('Minutes')}</Option>
                <Option value="h">{_('Hours')}</Option>
                <Option value="D">{_('Days')}</Option>
                <Option value="W">{_('Weeks')}</Option>
                <Option value="M">{_('Months')}</Option>
                <Option value="Y">{_('Years')}</Option>
            </Select>
        </span>
    );
});

export default Frequency;
